function updateCountdown(hours, pointer) {

    var startDate = new Date("2024-11-17T13:00:00"); // hardcoded date
    var interval = hours * 60 * 60 * 1000; // hours in milliseconds
    var now = new Date();
    var elapsed = now - startDate; // The time between the hardcoded date and now
    var timeInCurrentInterval = elapsed % interval;
    var timeLeft = interval - timeInCurrentInterval;
  
    var hours = Math.floor(timeLeft / (1000 * 60 * 60)); // Remaining full hours
    var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
  
    var formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  
    // Display in the product counter
    var countdownElement = document.querySelector(pointer);
    if (countdownElement) {
      countdownElement.textContent = formattedTime;
    }
  
    // Add logic to display in custom announcement bar here
  
  }